import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { ToastCallback } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_generation_update_name } from '@/state/generation/entity/remote_generation_update_name';
import { REMOTE__generation_update_tool } from '@/state/generation/settings/REMOTE__generation_update_tool';
import { REMOTE__generation_update_tool_name } from '@/state/generation/settings/REMOTE__generation_update_tool_name';
import { REMOTE__generation_consume_content } from '@/state/generation/user_task/REMOTE__generation_consume_content';
import { store } from '@/state/store';
import { assert_false, assert_hash_sha256_not_empty, assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTOImageAiDescription } from '@shared/dto/+image/image_ai_description/dto_image_ai_description';
import { DTO_REQUEST__generation_consume_content } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_consume_content';
import { RequestGenerationUpdateName } from '@shared/dto/generation/_requests/request_generation_update_name';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { ENUM__graph_template_name } from '@shared/dto/generation/graph_invoke/_templates/sd_1/ENUM__graph_template_name';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { useTranslation } from 'react-i18next';

export class UTILS__generation {
  static async update_tool(tool: DTO__generation_tool) {
    let { generation_current } = store.getState().slice_generation;

    let tool_new = tool.clone();
    tool_new.init_for_generation(generation_current._id);

    let { graph } = tool_new;

    graph.values_allowed__fill();

    graph.fields_store__fill_from(generation_current.fields_store);

    await store.dispatch(REMOTE__generation_update_tool(tool_new));
  }

  static async update_tool_name_as_custom(tool: DTO__generation_tool) {
    tool = tool.clone();
    tool.name = ENUM__graph_template_name.CUSTOM;

    await store.dispatch(REMOTE__generation_update_tool_name(tool));
  }
}

/*
 * PRICE
 */

export function get_generation_current_generation_price(skip_generated_images: boolean) {
  let { generation_prices_by_hashes_map } = store.getState().slice_generation_price;
  let { generation_current } = store.getState().slice_generation;
  let { grids2d_map } = store.getState().slice_grid2d;

  if (generation_current.is_stub()) return NaN;

  let grid2d = grids2d_map.get(generation_current._id);
  if (!grid2d) return NaN; //grid2d is not loaded yet

  assert_instanceof(grid2d, DTO__grid2d_generation);

  let grid2d_chunk_generation = grid2d.get_generation_chunk();

  let out = 0;

  for (let cell of grid2d_chunk_generation.cells_list) {
    if (cell.image.is_generated() && skip_generated_images) continue; //already generated

    let hash = cell.image.hash_generated_settings_clean;

    if (generation_prices_by_hashes_map.has(hash)) {
      let price_data = generation_prices_by_hashes_map.get_or_assert(hash);
      out += price_data.price_credits;
    } else {
      //we cant determine price now
      out = NaN;
      break;
    }
  }

  return out;
}

export async function set_generation_name(generation_id: string, name: string) {
  let request = new RequestGenerationUpdateName();
  request.generation_id = generation_id;
  request.name = name;

  await store.dispatch(remote_generation_update_name(request));
}

export async function show_toast_ai_description(toast: ToastCallback, ai_description: DTOImageAiDescription) {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  await navigator.clipboard.writeText(ai_description.description);

  toast({ title: t(i18n_base_ui.toasts.ai_description_copied_to_clipboard.title), description: ai_description.description });
}

/*
 *
 */

export async function FN_GENERATION__consume_content(generation: DTO__generation, hash_sha256_content: string, toast: ToastCallback) {
  let out = false;

  assert_false(generation.is_stub());
  assert_false(generation.graph_field_consumer.is_stub());

  assert_hash_sha256_not_empty(hash_sha256_content);

  let request = new DTO_REQUEST__generation_consume_content();
  request.generation_id_consumer = generation.graph_field_consumer.meta.graph_id;
  request.field_id_consumer = generation.graph_field_consumer.meta.field_id;
  request.hash_sha256_content = hash_sha256_content;

  let action_result = await store.dispatch(REMOTE__generation_consume_content(request));

  let response = action_result.payload;

  if (response instanceof DTO_RESPONSE__success) {
    toast({ title: `Content was consumed in ${generation.graph_field_consumer.meta.field_role}`, duration: CONSTANTS_TIME__client.SECONDS_3 });
    out = true;
  } else if (response instanceof DTO_RESPONSE__error) {
    toast({ title: 'Content was not consumed', description: response.type });
  }

  return out;
}
